import { Component, Injector, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { InputTypeComponentBase } from '../input-type-component-base';

@Component({
    selector: 'app-single-line-string-input-type',
    templateUrl: './single-line-string-input-type.component.html',
    styleUrls: ['./single-line-string-input-type.component.css'],
    imports: [FormsModule]
})
export class SingleLineStringInputTypeComponent extends InputTypeComponentBase implements OnInit {
  selectedValue: string;

  constructor(
    injector: Injector,
  ) {
    super(injector);
  }

  getSelectedValues(): string[] {
    if (!this.selectedValue) {
      return [];
    }
    return [this.selectedValue];
  }

  ngOnInit(): void {
    this.selectedValue = this.selectedValues[0];
  }
}
